<div class="container">

  <form class="likes-form" [formGroup]="engagementFormGroup">

    <mat-form-field appearance="outline" class="post-url compact-form">
      <mat-label>קישור לפוסט</mat-label>
      <input matInput formControlName="postUrl" (blur)="onPostUrlBlur()" />

      @if (engagementFormGroup.get('postUrl')?.hasError('required')) {
        <mat-error>
          שדה חובה
        </mat-error>
      }

      @if (engagementFormGroup.get('postUrl')?.hasError('pattern')) {
        <mat-error>
          פורמט קישור לא תקין
        </mat-error>
      }
    </mat-form-field>

    <div class="row-container">

      <mat-form-field appearance="outline" class="interval-seconds compact-form">
        <mat-label>מרווח בשניות</mat-label>
        <input matInput type="number" inputmode="numeric" formControlName="intervalSeconds" (keypress)="onlyNumbers($event)" />
        <mat-error>
          שדה חובה
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="date-picker-field compact-form">
        <mat-label>בחר תאריך</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="startDate">
        <mat-hint>DD.MM.YYYY</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline" class="time-picker-field compact-form">
        <mat-label>שעה</mat-label>
        <input matInput type="time" formControlName="startTime">
      </mat-form-field>

    </div>

    <div class="import-section" dir="rtl">
      <input type="file" #fileInput hidden (change)="onFileUpload($event)" accept=".xlsx">

      <div class="button-row">

        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="add-input compact-form">
          <mat-label>הוסף תגובה...</mat-label>
          <input matInput [ngModel]="newItemText()" (ngModelChange)="newItemText.set($event)" [ngModelOptions]="{standalone: true}" (keyup.enter)="addItem()">
        </mat-form-field>

        <button mat-icon-button color="primary" (click)="addItem()" [disabled]="!newItemText().trim()" matTooltip="הוסף תגובה מתיבת טקסט">
          <mat-icon>add</mat-icon>
        </button>

        <div class="divider"></div>

        <input type="file" #fileInput hidden (change)="onFileUpload($event)" accept=".xlsx">

        <button mat-icon-button color="primary" (click)="fileInput.click()" matTooltip="טען תגובות מאקסל">
          <mat-icon>upload</mat-icon>
        </button>

        <div class="divider"></div>

        <button mat-icon-button color="primary" matTooltip="צור תגובות באמצעות AI" (click)="openAiCommentGenerator()">
          <mat-icon>auto_fix_high</mat-icon>
        </button>

        @if (engagementFormGroup.get('commentList')?.value?.length > 0) {

          <button mat-icon-button color="accent"
            [disabled]="!list() || !list()!.selectedOptions.selected.length"
            (click)="deleteSelected()" matTooltip="מחק בחירה">
            <mat-icon>delete</mat-icon>
          </button>

          <button mat-icon-button color="accent" (click)="clearList()" matTooltip="נקה רשימה">
            <mat-icon>delete_sweep</mat-icon>
          </button>
        }
      </div>

      <div class="scroll-container">
        @if (isGenerating()) {
          <div class="loader-state">
            <mat-spinner diameter="40"></mat-spinner>
            <p>מייצר תגובות...</p>
          </div>
        } @else {
          <mat-selection-list #list [multiple]="false">
            @for (item of engagementFormGroup.get('commentList')?.value; track $index) {
              <mat-list-option [value]="item" [matTooltip]="item" togglePosition="before" (dblclick)="editItem($index)" (click)="onOptionClick($event, $index)">
                @if (editingIndex() === $index) {
                  <input matInput [ngModel]="editingText()" (ngModelChange)="editingText.set($event)" [ngModelOptions]="{standalone: true}"
                    (keyup.enter)="saveEdit($index)" (keyup.escape)="cancelEdit()"
                    (blur)="saveEdit($index)" class="inline-edit-input">
                  } @else {
                    {{ item }}
                  }
                </mat-list-option>
                } @empty {
                <div class="empty-state">
                  <mat-icon>info</mat-icon>
                  <p>No data loaded yet.</p>
                </div>
              }
            </mat-selection-list>
          }
        </div>

        @if (engagementFormGroup.hasError('avatarCountError')) {
          <mat-error>שגיאה בבדיקת מספר אוואטרים</mat-error>
        }
        @if (engagementFormGroup.hasError('insufficientAvatars') && engagementFormGroup.get('postUrl')?.touched) {
          <mat-error>
            שגיאה: ישנם רק {{ engagementFormGroup.errors?.['insufficientAvatars'].available }} אווטארים בקבוצה,
            אך דרושים {{ engagementFormGroup.errors?.['insufficientAvatars'].required }} עבור התגובות
          </mat-error>
        }

        @if (isFacebook) {
          <!-- wrap the observable result in an object to get a truthy response even when the emttted value is 0 -->
          @if ({ val: (countAvatarsInGroup$ | async) }; as data) {
            @if (data.val !== null && !engagementFormGroup.hasError('insufficientAvatars')) {
              <div class="avatar-info">
                שים לב: מספר התגובות מוגבל ל- {{ data.val }} בהתאם לכמות האווטארים בקבוצה זו
              </div>
            }
          }
        }

      </div>


    </form>

  </div>